import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landingRedesign.scss";
import "../../Assets/Styles/pages/pricingPageRedesign.scss";
import Nav from "../../Components/LandingComponents/Nav";
import PricingHero from "../../Components/PricingComponents/PricingHero";
import Plans from "../../Components/PricingComponents/plans";
import PricingCompare from "../../Components/PricingComponents/PricingCompare";
import PricingHighlights from "../../Components/PricingComponents/PricingHighlights";
import PricingContactCTA from "../../Components/PricingComponents/PricingContactCTA";
import usePageMetadata from "../../Utils/usePageMetadata";

// The global Footer still renders below every route including this one. The global Header's
// desktop bar is suppressed for "/pricing" in Header.tsx's `condition()` -- Nav replaces it,
// same pattern as the landing/features pages.
const Pricing: React.FC = () => {
	usePageMetadata(
		"Pricing Plans - eZy WaterMark",
		"Choose the right plan for you. Select from our range of monthly or yearly subscriptions to access templates, high-resolution processing, and ad-free experience."
	);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="landing-redesign">
			<Nav />
			<PricingHero />
			<Plans />
			<PricingCompare />
			<PricingHighlights />
			<PricingContactCTA />
		</div>
	);
};

export default Pricing;
